import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { CoachAPI } from '../../../api/CoachAPI';
import { useSelector } from 'react-redux';
import Loader from '../../../component/Loader';
import { Autocomplete, Avatar, TextField } from '@mui/material';
import defaultProfileImg from "../../../assets/images/default_profile_img.png";
import { TiUserDeleteOutline } from "react-icons/ti";

const TeamPlayerList = () => {
    document.title = "Players";
    const { state } = useLocation();
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const [isLoading, setIsLoading] = useState(false);
    const [players, setPlayers] = useState([]);
    const [teamPlayers, setTeamPlayers] = useState([]);
    const [isUpdate, setIsUpdate] = useState(false);


    const findAllPlayers = async () => {
        try {
            setIsLoading(true);
            const response = await CoachAPI.findAllClubPlayer(selectedClub.clubId);
            setPlayers(response.Data);
        } catch (error) {

        } finally {
            setIsLoading(false);
        }
    }
    const findAllTeamPlayers = async () => {
        try {
            setIsLoading(true);
            const response = await CoachAPI.findAllTeamPlayer(state?.teamId);
            setTeamPlayers(response.Data);
        } catch (error) {

        } finally {
            setIsLoading(false);
        }
    }
    const addPlayerToTeam = async (members) => {
        const playerData = (members || []).map((player) => ({
            playerId: player?.playerId,
            isChild: player?.isChild
        }));
        if (!playerData.length) {
            return;
        }
        try {
            setIsLoading(true);
            await CoachAPI.postAddPLayerToTeam({
                teamId: state?.teamId,
                playerData,
            })
            setIsUpdate(true);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }
    const removePlayerToTeam = async (playerId, isChild) => {
        try {
            setIsLoading(true);
            await CoachAPI.deletePlayerFromTeam({
                teamId: state.teamId,
                playerId: playerId,
                isChild: isChild,
                childrenId: playerId
            })
            setIsUpdate(true);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        findAllPlayers();
    }, []);
    useEffect(() => {
        findAllTeamPlayers();
        isUpdate && setIsUpdate(false);
    }, [isUpdate])



    const createNewList = () => {
        const playerIds = teamPlayers.map((item) => item.playerId);

        const onlyInList = players.filter(item => !playerIds.includes(item.playerId));

        return onlyInList.map((player) => ({
            playerId: player?.playerId,
            label: player?.firstName + " " + player?.lastName,
            email:player?.email,
            profileImg: player?.profileLogo,
            isChild: player?.child
        }))
    }
    const playerList = createNewList();
    const calculateAge = (dobVal) => {
        const today = new Date();
        const dob = new Date(dobVal);
        return today.getFullYear() - dob.getFullYear();
    }

    return (
        <div className='sm_team_player_list_con'>
            {isLoading && <Loader />}
            <div className='sm_team_player_list_add_player'>
                <div>
                    <h1>Members</h1>
                    <p className="setup-guide-hint">Team roster — search and add members. This is not a chat group.</p>
                </div>
                <Autocomplete
                    options={playerList || []}
                    value={null}
                    isOptionEqualToValue={(option, value) => option.playerId === value.playerId}
                    onChange={(event, val) => {
                        if (val) {
                            addPlayerToTeam([val]);
                        }
                    }}
                    sx={{ minWidth: 280, maxWidth: 420 }}
                    renderInput={(params) => <TextField className='signup-text-input' {...params} label="Search and add a member" placeholder="Type a name" />}
                    renderOption={(props, option) => {
                        const { key, ...rest } = props;
                        return (
                            <li {...rest} key={key} className='sm_add_player_list_options' style={{ display: 'flex', gap: '15px' }}>
                                <Avatar src={`${import.meta.env.VITE_APP_BASE_URL}/user/user-profile-img/${option.profileImg}`} />
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <h4>{option.label}</h4>
                                    <p>{option?.email}</p>
                                </div>
                            </li>
                        );
                    }}
                />
            </div>
            <table className='sm_team_player_list_table'>
                <thead>
                    <tr>
                        <th align='left'></th>
                        <th align='left'>First Name</th>
                        <th align='left'>Last Name</th>
                        <th align='left'>Age</th>
                        <th align='left'>Date of Birth</th>
                        <th align='left'>Email</th>
                        <th align='center'>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {teamPlayers.length == 0 ?
                        <tr className='sm_no_player_found_in_team'>
                            <td colSpan={7}>No Player Found</td>
                        </tr>
                        :
                        <>
                            {teamPlayers?.map((player, index) =>
                                <tr key={index}>
                                    <td align='center'><Avatar sx={{ background: 'white' }} src={defaultProfileImg} /></td>
                                    <td align='left'>{player?.firstName}</td>
                                    <td>{player?.lastName}</td>
                                    <td align='left'>{calculateAge(player?.dob)}</td>
                                    <td>{player?.dob}</td>
                                    <td>{player?.email ? player.email : 'NA'}</td>
                                    <td align='center'><TiUserDeleteOutline className='sm_remove_player_from_team_icon' onClick={() => removePlayerToTeam(player.playerId, player.child)} /></td>
                                </tr>)}
                        </>}
                </tbody>
            </table>


        </div>
    )
}

export default TeamPlayerList